// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Generating from '../../static/images/generating.gif';
import NoResult from '../../static/images/noDataFound.png';
import { useInterval } from '../../hooks/customHooks';
import {
    getActiveReportRequest,
    downloadReportRequest,
} from '../../containers/Transactions/redux/transactions.actions';

// Custom hooks

// Actions

// Styles
import './viewDownloadStatus.scss';
import { downloadCheckerReportRequest, getActiveCheckerReportRequest } from 'containers/Checker/redux/checker.actions';
import { getActiveMakerReportRequest, downloadMakerReportRequest } from 'containers/Maker/redux/maker.actions';

const REFRESH_INTERVAL = 20000;

const ViewDownloadStatus = props => {
    const { actions, data, pageType } = props;
    const isGeneratingData = data && data.generating && data.generating.length;
    const isCompleteData = data && data.complete && data.complete.length;

    // eslint-disable-next-line space-before-function-paren
    useInterval(async () => {
        if ((pageType === 'Transactions' && isGeneratingData) || (isGeneratingData && !pageType)) {
            await actions.getActiveReportRequest(true);
        }
        if (pageType === 'Checker' && isGeneratingData) {
            await actions.getActiveCheckerReportRequest({ reportType: props.reportType });
        }
        if (pageType === 'Maker' && isGeneratingData) {
            await actions.getActiveMakerReportRequest({ reportType: props.reportType });
        }
    }, REFRESH_INTERVAL);

    useEffect(() => {
        if (pageType === 'Transactions') {
            actions.getActiveReportRequest({ reportType: props.reportType });
        } else if (pageType === 'Checker') {
            actions.getActiveCheckerReportRequest({ reportType: props.reportType });
        } else if (pageType === 'Maker') {
            actions.getActiveMakerReportRequest({ reportType: props.reportType });
        }else{
            actions.getActiveReportRequest({ reportType: props.reportType });
        }
    }, [pageType, actions, props.reportType]);

    const handleDownload = item => {
        if ((pageType === 'Transactions' && item.requestId) || (item.requestId && !pageType)) {
            actions.downloadReportRequest(item);
        }
        if (pageType === 'Checker' && item.requestId) {
            actions.downloadCheckerReportRequest(item);
        }
        if (pageType === 'Maker' && item.requestId) {
            actions.downloadMakerReportRequest(item);
        }
    };

    const handleRefresh = async () => {
        if (pageType === 'Transactions' && isGeneratingData || (isGeneratingData && !pageType)) {
            await actions.getActiveReportRequest(true);
        }
        if (pageType === 'Checker' && isGeneratingData) {
            await actions.getActiveCheckerReportRequest({ reportType: props.reportType });
        }
        if (pageType === 'Maker' && isGeneratingData) {
            await actions.getActiveMakerReportRequest({ reportType: props.reportType });
        }
    };

    return (
        <div className="view-download-status">
            {data ? (
                <>
                    {isGeneratingData ? (
                        <div className="status-tab">
                            <div className="status-text">
                                Your File is <span className="warn">Generating…… </span>
                                <br />
                                you can download it when it will be completed
                            </div>

                            <div className="status-icon">
                                <button className="refresh" onClick={handleRefresh} />
                            </div>
                        </div>
                    ) : null}

                    {isGeneratingData ? (
                        <div className="download-list generating">
                            <h2>Generating File</h2>
                            <ul>
                                {data.generating.map(item => (
                                    <li>
                                        <div className="file-name">{item.fileName}</div>
                                        <div className="status-icon loading">
                                            <img src={Generating} alt="File Generating" />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}
                    {isCompleteData ? (
                        <div className="download-list">
                            <h2>Recent File</h2>
                            <ul>
                                {data.complete &&
                                    data.complete.map(item => (
                                        <li>
                                            <div className="file-name">{item.fileName}</div>
                                            <div className="status-icon">
                                                <button className="download" onClick={() => handleDownload(item)} />
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    ) : null}
                </>
            ) : (
                <div className="no-result">
                    <img src={NoResult} alt="No Result" />
                    No Generated files found.
                </div>
            )}
        </div>
    );
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            getActiveReportRequest,
            downloadReportRequest,
            getActiveCheckerReportRequest,
            downloadCheckerReportRequest,
            getActiveMakerReportRequest,
            downloadMakerReportRequest
        },
        dispatch
    ),
});

ViewDownloadStatus.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    refundData: PropTypes.object,
    reportType: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewDownloadStatus);
